<template>
  <v-menu
    :close-on-content-click="false"
    right
    max-height="80vh"
  >
    
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        x-large
        class="mr-3 text-hover hidden-md-and-up"
        v-bind="attrs"
        v-on="on"
      >
        mdi-chevron-down
      </v-icon>
    </template>

    <v-list>
      <v-expansion-panels
        accordion
        flat
      >
        <slot name="accordion-content"></slot>
      </v-expansion-panels>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: "FilterMenu",
    data: () => ({
      //
    })
  }
</script>

<style lang="scss" scoped>

</style>